<template>
    <section class="container">
      <div class="route">
        {{categoria}}
      </div>
      <div class="sidebar">
        <span class="principal">
          {{categoria}}
        </span>
      </div>
      <div class="window">
        <h1>Catálogo de componentes</h1>
        <div class="form-group">
          <form class="window-form" @submit.prevent="aceptar">

            <!-- DESPLEGABLE -->
            <md-list id="cuentaUnica">
              <md-list-item md-expand>
                <span class="md-list-item-text">Desplegable</span>
                <md-list slot="md-expand">
                  <!--
                  <select v-model="docenteSeleccionado" class="combo1" id="docente">
                    <option v-for="(docente,index) in docentes" :key="index" :value="docente">{{docente.nombre}}</option>
                  </select>
                  -->
                  

                    <!-- CAJA TEXTO -->
                    <label for="deudor">* Deudor</label>
                    <input class = "inputComponent" type="text" id="deudor" name="deudor" autocomplete="off" />

                    <!-- CAJA PASSWORD -->
                    <label for="actualPass">* Contraseña actual</label>
                    <input maxlength="6" class = "inputComponent" type="password" id="actualPass" name="actualPass" autocomplete="off"/>

                    <!-- COMBO -->
                    <label for="country">País</label>
                    <md-field class="anchoCombo100">
                      <md-select class="combo"  name="country" id="country" placeholder="Country">
                        <md-option value="australia">Australia</md-option>
                        <md-option value="brazil">Brazil</md-option>
                        <md-option value="japan">Japan</md-option>
                        <md-option value="united-states">ES66 3081 0026 6533 2323 4980</md-option>
                      </md-select>
                    </md-field>

                    <!-- COMBO PLANO HTML5 -->
                    <!--
                    <select v-model="docenteSeleccionado" class="combo1" id="docente">
                      <option v-for="(docente,index) in docentes" :key="index" :value="docente">{{docente.nombre}}</option>
                    </select>
                    -->

                    <!--COMPOSITE FECHA -->
                    <label for="fechaDesde">Fecha</label>
                    <div class="compositeComponent">
                      <md-datepicker class = "" id="fechaDesde" name="fechaDesde" v-model="model.fechaDesde" md-immediately><label class="insideLabel">Desde</label></md-datepicker>
                      <md-datepicker class = "" id="fechaHasta" name="fechaHasta" v-model="model.fechaHasta" md-immediately><label class="insideLabel">Hasta</label></md-datepicker>
                    </div>
                    

                    <!--COMPOSITE IMPORTE -->
                    <label for="importeDesde">Importe</label>
                    <div class="compositeComponent">
                      <div class = "importe inputComponent">
                        <input  type="number" id="importeDesde" step="any" name="importeDesde" autocomplete="off" placeholder="Desde" v-model="model.importeDesde"/>
                        <span class="icon">€  </span>
                      </div>
                      <div class = "importe inputComponent lastElement">
                        <input type="number" id="importeHasta" step="any" name="importeHasta" autocomplete="off" placeholder="Hasta" v-model="model.importeHasta"/>
                        <span class="icon">€  </span>
                      </div>
                    </div>

                    <!-- CHECKBOX -->
                    <div class="margenCheckSwitch">
                      <md-checkbox v-model="condiciones">Texto para el combo</md-checkbox>
                    </div>

                    <!-- SWITCH -->
                    <div class="margenCheckSwitch">
                    <md-switch v-model="boolean">Texto para el Switch</md-switch>
                    </div>

                    <!-- LOADER -->
                    <button style="width:80px; margin: 5px; padding: 5px; height: 40px; border-radius:7px; font-size: 16px; background: #9fe09f99" @click="showNewLoader">Loader</button>

                    <!--TABLA -->
                    <md-table v-model="ordenesCandidatas">
                      <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                        <md-table-cell md-label="Orden" md-sort-by="id">{{ item.id }}</md-table-cell>
                        <md-table-cell md-label="Deudor" md-sort-by="name">{{ item.name }}</md-table-cell>
                        <md-table-cell md-label="Importe" md-sort-by="email"><span class="importeLista">{{ item.email }}</span></md-table-cell>
                        <md-table-cell md-label="Fecha Vcto." md-sort-by="gender">{{ item.gender }}</md-table-cell>
                        <md-table-cell md-label="F. Alta Fact." md-sort-by="title">{{ item.title }}</md-table-cell>
                        <md-table-cell md-label="Concepto" md-sort-by="title">{{ item.title }}</md-table-cell>
                        <md-table-cell md-label="Comisiones" md-sort-by="gender">{{ item.title }}</md-table-cell>
                        <md-table-cell md-label="Tipo Interés" md-sort-by="title">{{ item.title }}</md-table-cell>
                      </md-table-row>
                    </md-table>

                </md-list>
              </md-list-item>
            </md-list>

            <!-- Botones para mostrar alertas -->
            <md-list id="cuentaUnica">
              <md-list-item md-expand>
                <span class="md-list-item-text">Alertas</span>
                <md-list slot="md-expand">
            
                  <div style="display:flex; justify-content:flex-start; margin-top:10px; margin-bottom:20px">
                    <button style="margin: 5px; padding: 5px; height: 40px; border-radius:7px; font-size: 16px; background: #1caff552" @click="alertaConfirmacion">Confirmación</button>
                    <button style="margin: 5px; padding: 5px; height: 40px; border-radius:7px; font-size: 16px; background: #9fe09f99" @click="alertaOperacionRealizada">Operación Realizada</button>
                    <button style="margin: 5px; padding: 5px; height: 40px; border-radius:7px; font-size: 16px; background: #f71616a6" @click="alertaError">Error</button>
                  </div>

                </md-list>
              </md-list-item>
            </md-list>

              <!-- TECLADO VIRTUAL -->
              <md-list id="firmaOrdenesMarcadas">
              <md-list-item>
                <span class="md-list-item-text">Firma Transferencia</span>
              </md-list-item>
            </md-list>
            <label class="labelClaveFirma">Introduzca las posiciones solicitadas de su clave de firma</label>
            <div class="claveFirma">
              <div class="providerReference"> <!--En un futuro este div se generara de manera dinamica, como el teclado virtual-->
                <input class="inputLoginComponent primeraPosicion" disabled type="text" name="firstGroup" maxlength="1" value="*">
                <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" v-model="providerReference.firstGroup" required>
                <input class="inputLoginComponent" disabled type="text" name="secondGroup" maxlength="1" v-model="providerReference.secondGroup" required>
                <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" value="*">
                <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" value="*">
                <input class="inputLoginComponent" disabled type="text" name="thirdGroup" maxlength="1" v-model="providerReference.thirdGroup" required>
                <input class="inputLoginComponent" disabled type="text" name="fourthGroup" maxlength="1" v-model="providerReference.fourthGroup" required>
                <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" value="*">
              </div>
              <div class="botonera">
                <div class="botones">
                  <button v-for="num in numeros" v-bind:key="num" class="botonPantalla" @click="tecladoVirtual($event)">{{num}}</button>
                </div>
                <button class="botonBorrar" @click="borrar()">
                  Borrar
                </button>
              </div>
            </div>
                  
            <!-- Boton aceptar -->
            <input class="btnPrimary" type="submit" value="Aceptar">
          </form>
        </div>
      </div>
    </section>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import PaymentAccount from '../models/PaymentAccount';
import ProviderReference from '../models/ProviderReference';
import Swal from 'sweetalert2';
export default {
    name : 'ComponentsCatalogComponent',
    data(){
      return{
        categoria:'Componentes',
        active: true,
        active2: false,
        submitted: false,
        model : new PaymentAccount(),
        providerReference : new ProviderReference(),
        ordenesCandidatas: [ //DATOS PROVISIONALES DE PRUEBA
          {
            id: 1.45,
            name: 'Shawna Dubbin',
            email: 'sdubbin0@geocities.com',
            gender: 'Male',
            title: 'Assistant Media Planner'
          },
          {
            id: 1.44,
            name: 'Odette Demageard',
            email: 'odemageard1@spotify.com',
            gender: 'Female',
            title: 'Account Coordinator'
          },
          {
            id: 3,
            name: 'Lonnie Izkovitz',
            email: 'lizkovitz3@youtu.be',
            gender: 'Female',
            title: 'Operator'
          }
        ],
        condiciones:false,
        boolean : false,
        numeros:null,
        datosSalida:false, //PROVISIONAL, SIMULA LA LISTA DE SALIDA PARA MOSTRARLA CUANDO LLAMEMOS AL SERVICE
        /*docentes : [
            {
                "id": 11,
                "nombre": "Federico"
            },
            {
                "id": 12,
                "nombre": "Alex"
            },
            {
                "id": 13,
                "nombre": "Jaime"
            },
            {
                "id": 14,
                "nombre": "Eduardo"
            }
        ],
        docenteSeleccionado: {}//<-- el seleccionado estará aquí*/
      }
    },
    computed : {
      isDisabled: function() {
        return  !this.model.account;
      },
      isDisabled2: function() { //aqui pondremos los campos obligatorios de nuestro form
        return  !this.condiciones || !this.providerReference.firstGroup || !this.providerReference.secondGroup || !this.providerReference.thirdGroup || !this.providerReference.fourthGroup;
      }
    },
    validations : {
      model : {
        account: {
          required
        }
      }
    },
    mounted: function(){
      var arrayTeclado=new Array();
      var numActual;
      var i;
      for(i=0;i<10;i){
        numActual=Math.floor(Math.random() * 10);
        if(!arrayTeclado.includes(numActual)){
          arrayTeclado.push(numActual);
          i++;
        }
      }
      this.numeros=arrayTeclado;
    },
    methods: {
      tecladoVirtual(elemento){
        if(!this.providerReference.firstGroup){
            this.providerReference.firstGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.secondGroup){
            this.providerReference.secondGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.thirdGroup){
            this.providerReference.thirdGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.fourthGroup){
            this.providerReference.fourthGroup=elemento.target.innerHTML;
          }
      },
      borrar(){
        if(this.providerReference.fourthGroup){
          this.providerReference.fourthGroup=null;
        }else if(this.providerReference.thirdGroup){
          this.providerReference.thirdGroup=null;
        }else if(this.providerReference.secondGroup){
          this.providerReference.secondGroup=null;
        }else{
          this.providerReference.firstGroup=null;
        }
      },
      showNewLoader() {
        let loader = this.$loading.show();
        setTimeout(() => {
          loader.hide();
        }, 2000);
      },
      aceptar() {
        this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            alert("Validación correcta"); //se reemplazara en un futuro con la llamada al servicio
          }
      },
      alertaOperacionRealizada() {
        Swal.fire(
          'Operación realizada',
          ' ',
          'success'
        )
      },
      alertaError() {
        Swal.fire({
          icon: 'error',
          title: 'Se produjo un error',
          text: 'Descripción del error',
          //footer: '<a href>Why do I have this issue?</a>'
        })
      },
      alertaConfirmacion() {
        Swal.fire({
          title: 'Va a realizar la operación.',
          text: "¿Desea continuar?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success'
            )
          }
        })
      }
    }
}
</script>